var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VContainer',{attrs:{"fluid":""}},[_c('VRow',{attrs:{"dense":""}},[_c('span',{staticClass:"search-total-result"},[_vm._v(" ("+_vm._s(_vm.totalResult)+" "+_vm._s(_vm.pluralizedResultWord)+") ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }